/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import kebabCase from 'lodash/kebabCase';
import { suggestionsGroupHeadingStyles } from './styles';
/**
 * While this component is a simple heading, it's been integrated in case
 * future needs require it to be more complex.
 */
export var ListHeading = function ListHeading(_ref) {
  var heading = _ref.heading;
  var listHeadingRef = useRef(null);
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("li", {
      css: suggestionsGroupHeadingStyles,
      ref: listHeadingRef
    }, jsx("h3", {
      className: "list-heading-text",
      "data-testid": "list-heading-".concat(kebabCase(heading))
    }, heading))
  );
};